import { render, staticRenderFns } from "./GLoading.vue?vue&type=template&id=64f58176&scoped=true&"
import script from "./GLoading.vue?vue&type=script&lang=ts&"
export * from "./GLoading.vue?vue&type=script&lang=ts&"
import style0 from "./GLoading.vue?vue&type=style&index=0&id=64f58176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f58176",
  null
  
)

export default component.exports